<template>
    <div class="app">
        <Slideout ref="slideout" menu=".menu" panel=".panel" :toggleSelectors="['.toggle-button']" @on-open="onOpen">
            <page-menu />
            <main class="panel" @click="RwdPanelToggle()" v-bind:style="`padding-top:${panelPadding}px;`">
                <page-header />
                <router-view></router-view>
                <page-footer />
            </main>
        </Slideout>
        <page-modal></page-modal>
        <Loading />
    </div>
</template>

<script>
    import $ from 'jquery'
    import Slideout from 'vue-slideout'
    import Menu from './components/Menu'
    import Header from './components/Header'
    import Footer from './components/Footer'
    import Modal from './components/Modal'
    import Loading from './components/partial/Loading'
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import accountApi from '@/api/account';

    // @click.native="something" 監聽 components 的原生 html 事件


    export default { // 傳導出去
        name: 'app',
        data() { // 使用資料,變數
            return {
                open: false,
                panelPadding: 0
            };
        },
        components: { // 您的樣板
            Slideout: Slideout,
            PageMenu: Menu,
            PageHeader: Header,
            PageFooter: Footer,
            PageModal: Modal,
            Loading
        },
        computed: { // 存放資料,變數
            //   toggleSelectors () {
            //       if (this.open) {
            //           return ['.panel'];
            //       }
            //       return ['.toggle-button'];
            //   },
          ...mapGetters('user', ['isLogin'])
        },
        mounted() { // 全部加載完成後
            // $refs components 的 id
            this.$refs.slideout.slideout.on('close', () => {
                this.open = false;
            });
        },
        created() {
            window.addEventListener('resize', this.PanelPaddingHandleResize)
            this.PanelPaddingHandleResize()
            this.setCompanyId('B0');
            this.loadRegisterUrl();
            this.loadForgetPwdUrl();
        },
        destroyed() {
            window.removeEventListener('resize', this.PanelPaddingHandleResize)
        },
        watch: {
            '$route.query' : {
                handler(val) {
                  if (val.key) {
                    if(!this.isLogin) {
                      if (val.path) {
                        accountApi.ssoToken({
                          Key: val.key
                        }, (data) => {
                          this.setUser(data);
                          this.$router.push({path: val.path, replace: true});
                        }, () => {});
                      } else {
                        accountApi.ssoToken({
                          Key: val.key
                        }, (data) => {
                          this.setUser(data);
                          this.$router.push({path: '/home', replace: true})
                        }, () => {});
                      }
                    }
                  }
                },
                immediate: true,
                deep: true,
            },
            '$route.query.token': {
                handler(val) {
                    if (val) {
                        this.oAuth(val, () => {
                            this.removeUrlQueryParam('token');
                        });
                    }
                },
                immediate: true,
            },
            '$route.query.company_id': {
                handler(val) {
                    if (val) {
                        this.setCompanyId(val);
                        this.removeUrlQueryParam('company_id');
                    }
                },
                immediate: true,
            }
        },
        methods: { // 執行事件
            ...mapMutations('advancedSearch', [
                'setCompanyId',
            ]),
            ...mapMutations('user', [
                'setUser',
            ]),
            ...mapActions('home', [
              'loadRegisterUrl'
            ]),
            ...mapActions('home', [
              'loadForgetPwdUrl'
            ]),
            removeUrlQueryParam(name) {
                let query = Object.assign({}, this.$route.query);
                delete query[name];
                this.$router.replace({ query });
            },
            oAuth(token, cb) {
                accountApi.oAuth({
                    Token: token,
                }, (data) => {
                    this.setUser(data);
                    if (cb) {
                        cb();
                    }
                });
            },
            onOpen() {
                this.open = true;
            },
            RwdPanelToggle() {
                if (this.open) {
                    this.$refs.slideout.slideout.close();
                    this.open = false;
                }
            },
            PanelPaddingHandleResize() {
                $(document).ready(() => {
                    let WindowH = window.innerHeight,
                        HeaderH = $('header').outerHeight(true),
                        Pd = WindowH - (WindowH - HeaderH) + 10
                    if (window.innerWidth <= 767) Pd = $('.hbt_menu').outerHeight(true) * 0
                    this.panelPadding = Pd
                })
            },
        }
    }
</script>
